import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { ReplaySubject } from "rxjs";

@Component({
  selector: "app-multi-select",
  templateUrl: "./multi-select.component.html",
  styleUrls: ["./multi-select.component.scss"],
})
export class MultiSelectComponent implements OnInit, OnChanges {
  @Input() label!: string;
  @Input() placeholder: string = "Select";
  @Input() control!: FormControl;
  @Input() options: any[] = [];
  @Input() optionLabel: string = "label";
  @Input() optionValue: string = "value";

  // Group Support
  @Input() group: boolean = false;
  @Input() groupLabel: string = "label";
  @Input() groupChildren: string = "items";

  searchCtrl: FormControl = new FormControl("");
  filteredOptions: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

  ngOnInit(): void {
    // Always initialize safely
    this.filteredOptions.next(this.options ? [...this.options] : []);

    this.searchCtrl.valueChanges.subscribe(() => {
      this.filterOptions();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["options"]) {
      this.filteredOptions.next(this.options ? [...this.options] : []);
    }
  }

  private filterOptions(): void {
    if (!this.options) {
      this.filteredOptions.next([]);
      return;
    }

    const search = this.searchCtrl.value?.toLowerCase() || "";

    // Reset if empty
    if (!search) {
      this.filteredOptions.next([...this.options]);
      return;
    }

    // GROUP MODE
    if (this.group) {
      const filteredGroups = this.options
        .map((group: any) => {
          const groupName = group[this.groupLabel]?.toLowerCase() || "";

          const children = group[this.groupChildren] || [];

          // If group name matches → return full group
          if (groupName.includes(search)) {
            return group;
          }

          // Otherwise filter children
          const filteredChildren = children.filter((child: any) =>
            child[this.optionLabel]?.toLowerCase().includes(search),
          );

          return filteredChildren.length
            ? { ...group, [this.groupChildren]: filteredChildren }
            : null;
        })
        .filter((group: any) => group !== null);

      this.filteredOptions.next(filteredGroups);
    }

    // NORMAL MODE
    else {
      const filtered = this.options.filter((option: any) =>
        option[this.optionLabel]?.toLowerCase().includes(search),
      );

      this.filteredOptions.next(filtered);
    }
  }
}
